import { Box, ListItemButton, ListItemIcon, Typography } from '@mui/material'
import { ReactNode } from 'react'
import { COLORS } from '~theme/colors'
import { useNavigation } from '../../navigation-context'

const textDefaultColor = (isActive: boolean) =>
  isActive ? 'white' : COLORS.secondary.darkBlue
const textHoverColor = (isActive: boolean) =>
  isActive ? COLORS.secondary.lightBlue : COLORS.secondary.darkBlue
const iconHoverColor = (isActive: boolean) =>
  isActive ? COLORS.secondary.lightBlue : 'white'
const listItemDefaultBackgroundColor = (isActive: boolean) =>
  isActive ? COLORS.primary.maerskBlue : 'transparent'
const listItemHoverBackgroundColor = (isActive: boolean) =>
  isActive ? COLORS.primary.maerskBlue : COLORS.secondary.blueTint
const iconBackgroundColor = (isActive: boolean) =>
  isActive ? COLORS.primary.maerskBlue : COLORS.primary.maerskBlue

export function MenuItemWithIconInCircle({
  icon,
  label,
  isActive,
}: {
  icon: ReactNode
  label: string
  isActive: boolean
}) {
  const { isOpen: isMenuOpen } = useNavigation()

  return (
    <ListItemButton
      sx={[
        {
          mt: 2,
          px: 1,
          color: textDefaultColor(isActive),
          backgroundColor: listItemDefaultBackgroundColor(isActive),
          '&:hover': {
            backgroundColor: listItemHoverBackgroundColor(isActive),
            '& path': {
              fill: iconHoverColor(isActive),
            },
            '& a, span': {
              color: textHoverColor(isActive),
            },
          },
          minHeight: 48,
          display: 'flex',
          flexDirection: isMenuOpen ? 'row' : 'column',
          justifyContent: isMenuOpen ? 'initial' : 'center',
          mx: 2,
          borderRadius: 1,
        },
      ]}
    >
      <ListItemIcon
        sx={{
          minWidth: 0,
          justifyContent: 'center',
          mr: isMenuOpen ? 3 : 0,
          transition: 'color 0.2s',
          '& svg': {
            width: '24px',
            height: '24px',
          },
          background: iconBackgroundColor(isActive),
          borderRadius: '50%',
          p: 2,
          color: COLORS.primary.white,
        }}
      >
        {icon}
      </ListItemIcon>

      {label && (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: isMenuOpen ? 'space-between' : 'center',
          }}
        >
          <Typography
            variant={isMenuOpen ? 'menuBold' : 'graphCaption'}
            sx={[
              isMenuOpen ? { mt: 0 } : { fontSize: '8px', mt: 1 },
              {
                whiteSpace: 'break-spaces',
                textAlign: 'center',
                color: textDefaultColor(isActive),
              },
            ]}
          >
            {label}
          </Typography>
        </Box>
      )}
    </ListItemButton>
  )
}
